<template>
  <div>
    <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="formLabelAlign">
      <el-form-item label="步骤名称">
        <el-input v-model="formLabelAlign.sendMessage" disabled style="width: 360px;"></el-input>
      </el-form-item>
      <el-form-item label="商户账号" prop="wechatId">
        <el-select @change="update" v-model="formLabelAlign.wechatId" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.nick_name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户名称" prop="name">
        <el-input @change="update" v-model="formLabelAlign.name" placeholder="红包发送者名称" style="width: 360px;"></el-input>
      </el-form-item>
      <el-form-item label="付款金额" prop="num" style="text-align: left;">
        <el-input-number style="margin-left: 10px" @change="update" v-model="formLabelAlign.num" controls-position="right" :min="1" :max="200"></el-input-number>&nbsp;元
      </el-form-item>
      <el-form-item label="祝福语" prop="goodLuck">
        <el-input @change="update" v-model="formLabelAlign.goodLuck" style="width: 360px;"></el-input>
      </el-form-item>
      <el-form-item label="活动名称">
        <el-input @change="update" v-model="formLabelAlign.activityName" style="width: 360px;"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input @change="update" v-model="formLabelAlign.remark" style="width: 360px;"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getWechatPublicListForNode } from '@/api/customer.js'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      options: [],
      labelPosition: 'right',
      formLabelAlign: this.contents,
      rules: {
        wechatId: [
          { required: true, message: '请选择商户', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入商户名称', trigger: 'change' }
        ],
        goodLuck: [
          { required: true, message: '请输入祝福语', trigger: 'change' }
        ],
        num: [
          { required: true, message: '请输入付款金额', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    update() {
      // 传值到父组件
      let choose = {}
      choose.nodeType = 'sendRedPacketsNode'
      choose.sendMessage = '发送红包'
      choose.wechatId = this.formLabelAlign.wechatId
      choose.name = this.formLabelAlign.name
      choose.id = this.formLabelAlign.id
      choose.num = this.formLabelAlign.num
      choose.goodLuck = this.formLabelAlign.goodLuck
      choose.activityName = this.formLabelAlign.activityName
      choose.remark = this.formLabelAlign.remark
      this.$emit('change', choose)
    },
    // 加载公众号列表
    loadWePages() {
      getWechatPublicListForNode(this.page).then((res) => {
        if (res.data.code === 0) {
          this.options = res.data.data.list
        }
      })
    }
  },
  watch: {
    contents: function (val) {
      this.formLabelAlign = val
    }
  },
  created() {
    this.loadWePages()
    console.log('contents', this.formLabelAlign)
  }
}
</script>

<style scoped>

</style>
